import React from "react";
import styled from "styled-components";
import AppLink from "components/common/style/link/AppLink";
import DeleteText from "components/common/style/navigation/DeleteText";
import { useUnitSearch } from "hooks/citajteo/dl_unit/useUnitSearch";
import { useUnitDelete } from "hooks/citajteo/dl_unit/useUnitDelete";
import { QUERY_KEYS } from "constant/react_query";
import { DlUnit } from "model/dl_unit/DlUnit";
import toast from "react-hot-toast";

const DlUnitList: React.FC = () => {
  const units = useUnitSearch();
  const { unitDeleteMutate } = useUnitDelete({
    invalidateKeys: [QUERY_KEYS.CITAJTEO_DL_UNIT_SEARCH],
  });

  const handleUnitDelete = (unit: DlUnit) => {
    const confirmed = window.confirm(
      `Da li želite da obrišete jedinicu ${unit.slug}?`,
    );

    if (!confirmed) {
      return;
    }

    unitDeleteMutate(unit.id, {
      onSuccess: () => {
        toast.success("Uspešno brisanje jedinice.");
      },
      onError: (error) => {
        console.error("Error deleting unit:", error);
        toast.error("Greška prilikom brisanja jedinice.");
      },
    });
  };

  return (
    <Content>
      <ContentInner>
        <NewItem>
          <AppLink to="/admin-dashboard/dl-unit-new">novo</AppLink>
        </NewItem>

        {units &&
          units.items.length > 0 &&
          units.items.map((item: DlUnit) => {
            const unit = new DlUnit(item);

            return (
              <ListItem key={unit.id}>
                <AppLink to={`/admin-dashboard/dl-unit-edit/${unit.id}`}>
                  polja
                </AppLink>
                <br />
                {unit.slug}
                <DeleteItem>
                  <DeleteText onClick={() => handleUnitDelete(unit)}>
                    obriši
                  </DeleteText>
                </DeleteItem>
              </ListItem>
            );
          })}
      </ContentInner>
    </Content>
  );
};

export default DlUnitList;

const Content = styled.div``;

const ContentInner = styled.div`
  width: 90%;
`;

const NewItem = styled.div`
  margin-top: 0;
`;

const ListItem = styled.div`
  margin-top: 1em;
  width: 100%;
  line-height: 1.5em;
`;

const DeleteItem = styled.div`
  margin-top: 0.5rem;
`;
